module.exports = __webpack_public_path__ + "operace-nosu_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_1_after.jpg
// module id = 1129
// module chunks = 0